var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c("label", [
          _vm._v(_vm._s(_vm.fieldData.field_label)),
          _vm.fieldData.field_required
            ? _c("span", { staticClass: "star" }, [_vm._v("*")])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          staticClass: "mb-0",
          attrs: {
            id: _vm.fieldData.field_section,
            "label-for": _vm.fieldData.field_name
          }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.fieldData.field_model,
                expression: "fieldData.field_model"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: {
                  required: _vm.fieldData.field_required,
                  min_value: _vm.fieldData.field_min_value,
                  max_value: _vm.fieldData.field_max_value
                },
                expression:
                  "{required: fieldData.field_required, min_value: fieldData.field_min_value, max_value:fieldData.field_max_value }"
              }
            ],
            class: _vm.fieldData.field_class,
            attrs: {
              type: "text",
              id: _vm.fieldData.field_id,
              name: _vm.fieldData.field_name,
              maxlength: _vm.fieldData.field_maxlength
            },
            domProps: { value: _vm.fieldData.field_model },
            on: {
              keypress: function($event) {
                return _vm.numberOnly($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.fieldData, "field_model", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has(_vm.fieldData.field_name),
                  expression: "errors.has(fieldData.field_name)"
                }
              ],
              attrs: { "force-show": true }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.errors.first(_vm.fieldData.field_name)) +
                  "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-1 smaller-font-content" }, [
        _vm._v(_vm._s(_vm.fieldData.field_subtext))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beb0b0b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beb0b0b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/interactive/InputNumberCustom.vue
// module id = null
// module chunks = 